import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ChangeLogDescription} from 'src/components/change-log';

import {
    accountAuditLogStateActions,
    accountAuditLogStateSelector,
} from '../slices/account-audit-log-state.slice';

type Props = {
    description: string,
};

export const ActionDescriptionCell = ({description}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(accountAuditLogStateSelector);
    const query = (cacheKeys.filters?.searchQuery ?? '') as string;

    const onEntityClick = useCallback((searchQuery: string) => {
        dispatch(accountAuditLogStateActions.setFilters({searchQuery}));
    }, [dispatch]);

    return (
        <ChangeLogDescription description={description} query={query} onEntityClick={onEntityClick}/>
    );
};
